module.exports = __webpack_public_path__ + "static/media/ai-ad-talarico-thumbnailDT.32f936ee.jpg";